<template>
  <q-tooltip>
    You do not have the required permissions to {{ actionDescription }}.
  </q-tooltip>
</template>

<script>
const ACTIONS = {
  VIEW: 'view',
  MANAGE: 'manage',
  DELETE: 'delete'
}

export default {
  name: 'ActionNotPermittedTooltip',
  props: {
    action: {
      type: String,
      required: false,
      default: ACTIONS.MANAGE
    }
  },
  computed: {
    actionDescription () {
      switch (this.action) {
        case ACTIONS.VIEW:
          return 'view details'
        case ACTIONS.MANAGE:
          return 'make changes'
        case ACTIONS.DELETE:
          return 'archive or delete'
        default:
          return 'access'
      }
    }
  }
}
</script>
